<template>
    <section id="PlayerSummaries">
        <div v-for="player in playersData.players">
            <div class="infos" v-show="showInfos">
                id: {{ player.steamid }} | last logoff: {{ player.lastlogoff | unix2date }} | status: {{ status(player) }}
            </div>
            <div class="player">
                <img class="avatar" v-bind:src="player.avatarmedium" alt="player.personaname">
                <h1 class="name">{{ player.personaname }}</h1>
                <button class="toggle" v-on:click="toggleInfos()">Infos</button>
            </div>
        </div>
    </section>


</template>

<script>
    export default{
        props: {
            playersData: {
                type: Object
            }
        },
        data() {
            return {
                showInfos: false
            }
        },
        methods: {
            status(player) {
                let state = '';

                switch(player.personastate) {
                    case 0:
                        state = 'offline/private';
                        break;
                    case 1:
                        state = 'online';
                        break;
                    case 2:
                        state = 'busy';
                        break;
                    case 3:
                        state = 'away';
                        break;
                    case 4:
                        state = 'snooze';
                        break;
                    case 5:
                        state = 'looking to trade';
                        break;
                    case 6:
                        state = 'looking to play';
                        break;
                    default:
                        state = 'n/a';
                }

                return state;
            },
            toggleInfos() {
                this.showInfos = !this.showInfos;
            }
        }
    }
</script>

<style scoped lang="scss">
    .infos {
        margin: -10px -10px 1em -10px;
        padding: 10px;
        background-color: black;
        color: white;
    }
    .player {
        display: flex;
        align-items: center;
        margin-bottom: 1em;
    }
    .avatar {
        flex: 0 0 auto;
    }
    .name {
        flex: 1 0 auto;
        padding: 0 10px;
        margin: 0;
    }
    .toggle {
        flex: 0 0 auto;
    }
</style>


// WEBPACK FOOTER //
// PlayerSummaries.vue?39ed9a3c